// product-variant-sync.js — Stiletto: miniatura data-variant-id -> select + swatch Color + label
// Versión estable: recarga completa en agotados (sin soft reload) + anti-carreras y reintentos
(function () {
  'use strict';

  const SEL = {
    thumb:  '.product-thumbnails__item-link', // aquí vive data-variant-id
    form:   'form[action*="/cart/add"]',
    select: 'select[name="id"]',
    swatch: '.product__color-swatch.dynamic-variant-button[data-option-value]',
    swatchContainer: '.product, .product-form, [data-section-type="product"]'
  };

  // Token anti-carreras (aumenta en cada clic de miniatura con variante)
  let SYNC_GEN = 0;

  // --- helpers ---
  function normalize(s) {
    return (s || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '') // quita tildes
      .replace(/ñ/g, 'n');            // vicuña -> vicuna
  }

  function getProductData() {
    try {
      const tag =
        document.querySelector('script[type="application/json"][data-product-json]') ||
        document.querySelector('script[type="application/json"][id^="ProductJson-"]');
      return tag ? JSON.parse(tag.textContent) : null;
    } catch {
      return null;
    }
  }

  // Actualiza el texto que muestra el valor seleccionado de "Color"
  function updateColorLabel(colorValue) {
    if (!colorValue) return;
    let updated = false;

    const selectors = [
      '.product-option--color [data-selected-value]',
      '.product-option--color .product-option__value',
      '.product__option-value[data-option="Color"]',
      '.product__selected-option[data-option="Color"]',
      '[data-selected-color]',
      '.product-options__value',
      '.product__option-value'
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = colorValue;
        updated = true;
      });
    });

    // Heurística: label "Color:" y su hermano
    if (!updated) {
      const scope = document.querySelector(SEL.swatchContainer) || document;
      scope.querySelectorAll('*').forEach(el => {
        const txt = (el.textContent || '').trim();
        if (/^color[:：]?$/i.test(txt)) {
          const next = el.nextElementSibling;
          if (next) {
            next.textContent = colorValue;
            updated = true;
          }
        }
      });
    }

    // Último recurso: insertar span al lado del label
    if (!updated) {
      const label = Array.from(document.querySelectorAll('*'))
        .find(n => /^color[:：]?$/i.test((n.textContent || '').trim()));
      if (label) {
        const span = label.nextElementSibling || document.createElement('span');
        span.textContent = colorValue;
        if (!label.nextElementSibling) label.parentNode.insertBefore(span, label.nextSibling);
      }
    }
  }

  // Localiza el botón-swatch para un color
  function findSwatchButton(colorValue) {
    const want = normalize(colorValue);
    const buttons = Array.from(document.querySelectorAll(SEL.swatch));
    return buttons.find(b => {
      const byVal   = normalize(b.dataset.optionValue);
      const byLabel = b.dataset.label ? normalize(decodeURIComponent(b.dataset.label)) : '';
      return byVal === want || byLabel === want;
    });
  }

  // Marca el swatch (si hay stock, simula click; si está agotado, fuerza visual igualmente)
  function clickColorSwatch(colorValue, opts = { force: false }) {
    const buttons = Array.from(document.querySelectorAll(SEL.swatch));
    const target = findSwatchButton(colorValue);
    if (!target) return false;

    // limpiar selección previa
    buttons.forEach(b => {
      b.classList.remove('selected', 'active');
      b.setAttribute('aria-pressed', 'false');
    });

    // simular click "real" para que el tema ejecute su lógica
    ['pointerdown','mousedown','click','mouseup','pointerup'].forEach(evt =>
      target.dispatchEvent(new MouseEvent(evt, { bubbles: true, cancelable: true, view: window }))
    );

    // marcar visualmente (incluido disabled)
    target.classList.add('selected', 'active');
    target.setAttribute('aria-pressed', 'true');

    return true;
  }

  // Reintentos para re-aplicar selección si el tema re-renderiza
  function syncColorUIWithRetries(colorValue, tries = 3, delay = 120, gen = SYNC_GEN) {
    if (gen !== SYNC_GEN) return; // abortar si hubo otro clic posterior

    clickColorSwatch(colorValue, { force: true });
    updateColorLabel(colorValue);
    if (tries <= 0) return;

    const container = document.querySelector(SEL.swatchContainer) || document.body;
    let handled = false;

    const mo = new MutationObserver(() => {
      if (handled) return;
      handled = true;
      mo.disconnect();
      if (gen !== SYNC_GEN) return;
      setTimeout(() => {
        if (gen !== SYNC_GEN) return;
        clickColorSwatch(colorValue, { force: true });
        updateColorLabel(colorValue);
        setTimeout(() => syncColorUIWithRetries(colorValue, tries - 1, delay, gen), delay);
      }, 0);
    });

    mo.observe(container, { subtree: true, childList: true, attributes: true });

    // fallback de tiempo si no hubo mutaciones
    setTimeout(() => {
      if (handled) return;
      mo.disconnect();
      if (gen !== SYNC_GEN) return;
      syncColorUIWithRetries(colorValue, tries - 1, delay, gen);
    }, delay);
  }

  function init() {
    const form = document.querySelector(SEL.form);
    if (!form) return;

    const select = form.querySelector(SEL.select);
    if (!select) return;

    const pd = getProductData();
    if (!pd || !Array.isArray(pd.variants)) return;

    // Índice de la opción "Color"
    const colorIdx = (pd.options || [])
      .map(o => (typeof o === 'string' ? o : o?.name) || '')
      .findIndex(n => normalize(n).includes('color'));

    // 1) Click en miniatura (usa data-variant-id determinístico)
    document.addEventListener('click', (e) => {
      const thumb = e.target.closest(SEL.thumb);
      if (!thumb) return;

      // Evitar doble cambio de imagen si la miniatura **sí** corresponde a variante
      if (thumb.hasAttribute('data-variant-id')) {
        e.preventDefault();
      }

      const vId = thumb.getAttribute('data-variant-id');
      if (!vId) return; // miniatura sin variante asociada: solo cambia la foto

      // invalidar reintentos/observers anteriores
      SYNC_GEN++;

      // Cambiar variante en el <select> para disparar la lógica del tema
      if (String(select.value) !== String(vId)) {
        select.value = String(vId);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Sincronizar swatch y label
      if (colorIdx >= 0) {
        const v = pd.variants.find(x => String(x.id) === String(vId));
        const colorVal = v?.options?.[colorIdx];
        if (colorVal) {
          // ¿agotado?
          const swBtn = findSwatchButton(colorVal);
          const isDisabled = swBtn && (swBtn.classList.contains('disabled') || swBtn.disabled);
          if (isDisabled) {
            // Hacer algo si esta sin stock
          }

          // En stock: sincroniza en caliente
          clickColorSwatch(colorVal, { force: true });
          updateColorLabel(colorVal);
        }
      }

      // Actualizar ?variant= en la URL
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', vId);
        window.history.replaceState({}, '', url.toString());
      } catch {}
    });

    // 2) Click manual en un swatch: actualizar label
    document.addEventListener('click', (e) => {
      const sw = e.target.closest('.product__color-swatch[data-option-value]');
      if (!sw) return;
      const val = sw.dataset.optionValue || (sw.dataset.label ? decodeURIComponent(sw.dataset.label) : '');
      if (val) updateColorLabel(val);
    }, true);

    // 3) Sincronización inicial (?variant=…)
    (function syncOnLoad() {
      const params = new URLSearchParams(window.location.search);
      const vid = params.get('variant');
      if (!vid) return;

      if (String(select.value) !== String(vid)) {
        select.value = vid;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (colorIdx >= 0) {
        const v = pd.variants.find(x => String(x.id) === String(vid));
        const colorVal = v?.options?.[colorIdx];
        if (colorVal) {
          setTimeout(() => {
            syncColorUIWithRetries(colorVal, 3, 120, SYNC_GEN);
          }, 30);
        }
      }
    })();
  }

  // Bootstrapping
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('shopify:section:load', init);
})();
